import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


const siteSliders = () => {
    const testimonialSlider = () => {
        // Variables
        let testimonialSliders = document.querySelectorAll('.testimonial-slider');
        // Check if testimonial sliders exist
        if (testimonialSliders.length === 0) {
            return;
        }
        // Loop through each testimonial slider
        testimonialSliders.forEach((slider) => {
            const slideCount = slider.querySelectorAll('.swiper-slide').length;
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1,
                loop: slideCount > 1,
                speed: 700,
                autoplay: {
                    delay: 1200,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        loop: slideCount > 2,
                    },
                    1200: {
                        slidesPerView: 3,
                        loop: slideCount > 3,
                    },
                    1400: {
                        slidesPerView: 4,
                        loop: slideCount > 4,
                    },
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                // navigation: {
                //     nextEl: '.swiper-testimonial-button-next',
                //     prevEl: '.swiper-testimonial-button-prev',
                // },
            });
        });
    };

    testimonialSlider();
};


// content loaded
document.addEventListener('DOMContentLoaded', () => {
    siteSliders();
});

